'use client';

import React, { useState } from 'react';
import styles from './styles/LandingFAQ.module.css';
const FAQS = [
  {
    question: 'What is PenguinLearn?',
    answer:
      'PenguinLearn is the learning platform where subject experts teach small-group classes. Our focus is on delivering high-quality, interactive lessons that help students build strong academic skills, confidence, and a genuine love for learning.',
  },
  {
    question: 'How do PenguinLearn classes work?',
    answer:
      'All classes are held via zoom and are limited to just 8 students. This small group setting allows for personalized attention, active participation, and a more supportive learning environment where every student is seen and heard.',
  },
  {
    question: 'Who are the tutors?',
    answer:
      'Our tutors are carefully selected subject experts chosen for their strong knowledge, teaching ability, and professionalism. Each instructor is evaluated for their communication skills and commitment to helping students succeed, ensuring a high-quality learning experience for every class.',
  },
  {
    question: 'How do you keep my child safe?',
    answer:
      'Your child’s safety is our top priority. All tutors undergo background checks before teaching on PenguinLearn. Classes are recorded for transparency, and are always visible to parents. Families also have full control over enrollment, schedules, and their child’s learning experience.',
  },
  {
    question: 'What is PenguinLearn’s refund policy?',
    answer: (
      <>
        <p>
          We want every family to feel confident when enrolling.
          <br />
          <br />
          • Cancel at least <strong>24 hours before</strong> the first live session for a full refund to your original payment method.
          <br />
          • After the first session, you’ll receive a refund for the remaining balance if you paid in full.
          <br />
          • If a scheduling conflict happens after enrollment and you paid in full, we’ll also refund your remaining balance.
          <br />
          <a
            href="https://www.penguinlearn.com/footer/refund"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#2563eb',
              textDecoration: 'underline',
              fontWeight: '500',
            }}
          >
            View full refund policy →
          </a>
        </p>
      </>
    ),
  },
];

export default function LandingFAQ() {
  return (
    <section className={styles.faqSection}>
      <h2 className={styles.faqTitle}>Frequently Asked Questions</h2>
      <p className={styles.faqSubtitle}>We are here to help!</p>

      <div className={styles.faqContainer}>
        {FAQS.map((faq) => (
          <FAQItem
            key={faq.question}
            question={faq.question}
            answer={faq.answer}
          />
        ))}
      </div>
    </section>
  );
}

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.faqItem}>
      <button
        type="button"
        className={styles.faqQuestion}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{question}</span>
        <span
          className={`${styles.arrow || ''} ${
            open ? styles.open || '' : ''
          }`}
        >
          ▾
        </span>
      </button>

      {open && <div className={styles.faqAnswer}>{answer}</div>}
    </div>
  );
}